import React from 'react';
import Logo from './Logo';
import { Linkedin, LucideFacebook, Mail } from 'lucide-react';
import { Link } from 'react-router';

export default function Footer() {
  return (
    <footer className="bg-[#273941] pt-12 text-white">
      <div className="container mx-auto px-10">
        <div className="grid grid-cols-1 gap-8 pb-[150px] md:grid-cols-5">
          {/* Logo and Social Links Column */}
          <div className="flex flex-col gap-6 space-y-6">
            <div className="text-white">
              <Logo isWhite={true} />
            </div>
            <div>
              <img
                src="/iso-27001.svg"
                alt="ISO/IEC 27001 certified"
                className="h-20 w-auto"
                loading="lazy"
              />
            </div>
            <div className="flex space-x-4">
              <Link
                to="https://www.linkedin.com/company/simulation-labs-linkedin/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white transition-colors hover:text-gray-300"
              >
                <Linkedin size={24} />
              </Link>
              <Link
                to="https://www.facebook.com/profile.php?id=61576677426002&mibextid=wwXIfr&mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white transition-colors hover:text-gray-300"
              >
                <LucideFacebook size={24} />
              </Link>
              <Link
                to="mailto:info@simulationslabs.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white transition-colors hover:text-gray-300"
              >
                <Mail size={24} />
              </Link>
            </div>
          </div>

          {/* Platform Column */}
          <div>
            <h3 className="mb-4 text-lg font-semibold">Platform</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/simulations-copilot"
                  className="text-gray-300 transition-colors hover:text-white"
                >
                  Simulations Copilot
                </Link>
              </li>
              <li>
                <Link to="/host-ctf" className="text-gray-300 transition-colors hover:text-white">
                  Launch Simulations
                </Link>
              </li>
              <li>
                <Link to="/deployment" className="text-gray-300 transition-colors hover:text-white">
                  Deployment Options
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-gray-300 transition-colors hover:text-white">
                  Pricing
                </Link>
              </li>
            </ul>
          </div>

          {/* Use Cases Column */}
          <div>
            <h3 className="mb-4 text-lg font-semibold">Use Cases</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/applicants-assessment"
                  className="text-gray-300 transition-colors hover:text-white"
                >
                  Applicants Assessment
                </Link>
              </li>
              <li>
                <Link
                  to="/employer-branding"
                  className="text-gray-300 transition-colors hover:text-white"
                >
                  Employer Branding
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources Column */}
          <div>
            <h3 className="mb-4 text-lg font-semibold">Resources</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/product-demo"
                  className="text-gray-300 transition-colors hover:text-white"
                >
                  Product Demo
                </Link>
              </li>
              <li>
                <Link to="/blogs" className="text-gray-300 transition-colors hover:text-white">
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  to="/case-studies"
                  className="text-gray-300 transition-colors hover:text-white"
                >
                  Case Studies
                </Link>
              </li>
              <li>
                <Link to="/guides" className="text-gray-300 transition-colors hover:text-white">
                  Guides
                </Link>
              </li>
              <li>
                <Link
                  to="https://support.simulationslabs.com/support/home"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 transition-colors hover:text-white"
                >
                  Help Center
                </Link>
              </li>
              <li>
                <Link
                  to="/simulationslabs-vs-ctfd"
                  className="text-gray-300 transition-colors hover:text-white"
                >
                  Simulations Labs vs CTFd
                </Link>
              </li>
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h3 className="mb-4 text-lg font-semibold">Company</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-gray-300 transition-colors hover:text-white">
                  About
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* Bottom Section */}
      <div className="mt-8 border-t border-gray-600 bg-white py-5">
        <div className="container mx-auto px-10">
          <div className="flex flex-col items-center justify-between space-y-4 md:flex-row md:space-y-0">
            <div className="text-sm text-gray-400">
              Copyright © Simulations Labs 2025. All Rights Reserved
            </div>
            <div className="flex space-x-6 text-sm">
              <Link
                to="/privacy-policy"
                className="text-gray-400 transition-colors hover:text-gray-600"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms-of-use"
                className="text-gray-400 transition-colors hover:text-gray-600"
              >
                Terms of Use
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
